export default __webpack_public_path__ + "static/media/nofriends.1cfd0456.svg";